export default __webpack_public_path__ + "static/section-team-3-beb2c8959c4bfba07ce21ee7be93de68.jpg";